import gql from 'graphql-tag';

export const RaceEntryFragment = gql`
  fragment RaceEntryFragment on RaceEntry {
    id
    status
    bookingId
    bookingType
    numberOfParticipants
    information {
      key
      value
    }
    groupId
    eventSummary {
      eventId
      title
      raceId
      raceStartDate
      raceTitle
      raceType
      submissionWindow {
        startDate
        endDate
      }
    }
  }
`;

const RaceEntryEventFragment = gql`
  fragment RaceEntryEventFragment on RaceEntry {
    event {
      id
      images {
        hero {
          medium
        }
      }
      place {
        address {
          city
          countryShort
        }
      }
      virtualEventDetails {
        isVirtual
      }
      title
      races {
        races {
          id
          information {
            sport
            distance
            metricLength
            raceUnit
            raceLength
          }
          title
        }
      }
    }
  }
`;

export const UpdateRaceEntryGroup = gql`
  mutation UpdateRaceEntry($id: ID!, $groupId: ID) {
    updateRaceEntry(input: { id: $id, groupId: $groupId }) {
      id
    }
  }
`;

export const RaceEntryFindAndUpdateByBookingId = gql`
  mutation RaceEntryFindAndUpdateByBookingId(
    $bookingId: ID!
    $eventId: ID
    $input: UpdateRaceEntryByBookingIdInput!
  ) {
    raceEntryFindAndUpdateByBookingId(
      bookingId: $bookingId
      eventId: $eventId
      input: $input
    ) {
      id
    }
  }
`;

export const CreateRaceEntry = gql`
  mutation CreateRaceEntry(
    $eventSummary: RaceEntryEventSummaryInput!
    $primaryIdentityId: ID
    $numberOfParticipants: Int!
    $status: RaceEntryStatusType!
    $information: [RaceEntryInformationInput]
    $year: Int
  ) {
    createRaceEntry(
      input: {
        eventSummary: $eventSummary
        primaryIdentityId: $primaryIdentityId
        numberOfParticipants: $numberOfParticipants
        status: $status
        information: $information
        year: $year
      }
    ) {
      ...RaceEntryFragment
      ...RaceEntryEventFragment
    }
  }
  ${RaceEntryFragment}
  ${RaceEntryEventFragment}
`;

export const CreateRaceEntries = gql`
  mutation CreateRaceEntries(
    $eventSummary: [RaceEntriesEventSummaryInput]!
    $primaryIdentityId: ID
    $numberOfParticipants: Int!
    $status: RaceEntryStatusType!
  ) {
    createRaceEntries(
      input: {
        eventSummary: $eventSummary
        primaryIdentityId: $primaryIdentityId
        numberOfParticipants: $numberOfParticipants
        status: $status
      }
    ) {
      id
    }
  }
`;

export const DeleteRaceEntry = gql`
  mutation DeleteRaceEntry($id: ID!) {
    deleteRaceEntry(id: $id)
  }
`;

export const UpdateRaceEntry = gql`
  mutation UpdateRaceEntry(
    $id: ID!
    $eventSummary: UpdateRaceEntryEventSummaryInput
    $primaryIdentityId: ID
    $numberOfParticipants: Int
    $status: RaceEntryStatusType
    $information: [RaceEntryInformationInput]
    $year: Int
  ) {
    updateRaceEntry(
      input: {
        eventSummary: $eventSummary
        id: $id
        primaryIdentityId: $primaryIdentityId
        numberOfParticipants: $numberOfParticipants
        status: $status
        information: $information
        year: $year
      }
    ) {
      ...RaceEntryFragment
      ...RaceEntryEventFragment
    }
  }
  ${RaceEntryFragment}
  ${RaceEntryEventFragment}
`;
